// extracted by css-extract-rspack-plugin
var _1 = "xyw7vQKOq1UFBK93";
var _2 = "c6ApIyXCFFYGkCWZ";
var _3 = "YQwzGFmDWD8NBiBA";
var _4 = "lIXwBnZASQy2PMNp";
var _5 = "L_hIAur3Q0YrSDGz";
var _6 = "c6ApIyXCFFYGkCWZ";
var _7 = "YQwzGFmDWD8NBiBA";
var _8 = "lIXwBnZASQy2PMNp";
var _9 = "L_hIAur3Q0YrSDGz";
var _a = "cTV1udoOLlg6s7b8";
var _b = "raaFiqsCgnp7ruR7";
var _c = "tSk8cEn0oIQDa3G7";
var _d = "raaFiqsCgnp7ruR7";
var _e = "tSk8cEn0oIQDa3G7";
var _f = "L2HB3wlJFwFWeqR_";
var _10 = "ulOceV93o6Mlg6DV";
export { _1 as "caption", _2 as "caption--l", _3 as "caption--m", _4 as "caption--s", _5 as "caption--xl", _6 as "captionL", _7 as "captionM", _8 as "captionS", _9 as "captionXl", _a as "section", _b as "section-title", _c as "sectionContent", _d as "sectionTitle", _e as "section__content", _f as "subtitle", _10 as "title" }
